import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AdminConfigService } from 'src/app/services/admin-config.service';

@Component({
  selector: 'app-delete-draft-conseil-config',
  templateUrl: './delete-draft-conseil-config.component.html',
  styleUrls: ['./delete-draft-conseil-config.component.scss'],
})
export class DeleteDraftConseilConfigComponent {
  @Input({ required: true }) configId: string;

  @Output() onDeleteConfig = new EventEmitter<string>();
  isLoading: boolean;

  constructor(private adminConfigService: AdminConfigService) {}

  async onDelete() {
    try {
      this.isLoading = true;
      await this.adminConfigService.deleteConseilConfig(this.configId);
      this.onDeleteConfig.emit(this.configId);
    } finally {
      this.isLoading = false;
    }
  }
}
